import { useEffect } from 'react'
import { Outlet } from 'react-router'
import Navbar from './components/Navbar'
import { useThemeStore } from './stores/theme';
import { useSubscriptionStatus } from './utils/query';
import { TriangleAlert, X } from 'lucide-react';


type WarningAlertProps = {
    message: string;
}

function WarningAlert(props: WarningAlertProps) {
    return (<div role="alert" className="alert alert-warning p-4">
        <TriangleAlert />
        <span>{props.message}</span>
        <button className="btn btn-circle btn-outline">
            <X size={20} />
        </button>
    </div>)
}

function Layout() {
    const { theme, resolvedTheme, detectSystemTheme } = useThemeStore();

    useEffect(() => {
        // Detect system theme initially
        if (theme === 'system') detectSystemTheme();

        // Set up a listener for system theme changes
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = () => detectSystemTheme();

        mediaQuery.addEventListener('change', handleChange);

        return () => mediaQuery.removeEventListener('change', handleChange);
    }, [theme, detectSystemTheme]);

    useEffect(() => {
        if (resolvedTheme === 'dark') {
            document.documentElement.classList.remove('light');
            document.documentElement.classList.add('dark');
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.classList.add('light');
            document.documentElement.classList.remove('dark');
            document.documentElement.setAttribute('data-theme', 'light');
        }
    }, [resolvedTheme]);

    const query = useSubscriptionStatus()


    return (
        <div>
            <Navbar />
            <div className="m-4">
                {query.data?.status === 'inactive' && <WarningAlert message='You need to renew your subscription to add more Nodes' />}
                <Outlet />
            </div>
        </div>
    )
}

export default Layout